import type FooterType from '../../../../types/Footer';
import { COPYRIGHT_FALLBACK } from '../../../core/constants';

type Props = {
  copyright?: FooterType['copyright'];
};

const FooterMini = ({ copyright = COPYRIGHT_FALLBACK }: Props) => {
  return (
    <footer className="bg-black py-3 text-white">
      <div className="text-center">
        <p className="text-mini">{copyright}</p>
      </div>
    </footer>
  );
};

export default FooterMini;
